import React, { Component } from 'react';
import App from "../../App";
import { Link, withRouter } from "react-router-dom";
import { getDetails } from "../../services/baseServices";
import { FaLongArrowAltLeft } from "react-icons/all";
import { getFormattedDate } from "../../helper/utils";
import ExportCSV from "../common/ExportCSV"
import _ from 'lodash'
import { DEBOUNCE_TIME } from "../../helper/env"

const headers = [
  { label: "Product", key: "product_title" },
  { label: "SKU", key: "sku" },
  { label: "Code by supplier", key: "code_by_supplier" },
  { label: "Quantity", key: "quantity" },
  { label: "Total Price", key: "total_price" },
];

const defaultState = {
  purchaseOrderItems: [],
  purchaseOrder: null,
  selectedRow: 0,
  received_quantity: 0,
  passed_quantity: 0,
  variant_id: null,
  isShowingQRGenerationModal: false,
  isLoading: true,
  selectedStartItemID: 0,
  selectedEndItemID: 0,
  startItemID: 0,
  endItemID: 0,
  QRInitial: '',
  colspan: 4,
  setQR:false,
  qrSku:null,
  orderLocations: {},
  selectedLocation: null,
}

class Details extends Component {
  constructor() {
    super();
    this.state = defaultState;
  };

  getData = () => {
    this.setState(defaultState)

    getDetails("wh_purchase_orders", this.props.match.params.id)
      .then(res => {
        this.setState({purchaseOrder: res, isLoading: false})
      })
      .catch(errMsg => {
        console.log('Err Msg: ', errMsg)
      })
  }

  componentDidMount() {
    this.getData()
  }

  debouncedOnAssignLocation = _.debounce((order_item_id)=>{
    this.assignLocation(order_item_id)
  }, DEBOUNCE_TIME);

  handleWithDebounceAssignLocation = async (order_item_id) => {
    this.debouncedOnAssignLocation(order_item_id);
  }
  
  render() {
    return (
      <App layout="">
        <div className="main-content">
          <div className="page-header">
            <h2 className="page-title">Purchase Order</h2>
            <div className="ml-auto">
              <Link to={`${process.env.PUBLIC_URL}/purchaseOrder/list`}
                    className="btn btn-sm btn-link"><FaLongArrowAltLeft/> Back to List</Link>
            </div>
          </div>

          {
            this.state.isLoading ?
              <div className={`card-block`}>
                <div className="block-body">
                  Loading...
                </div>
              </div>
              :
              <div className="card-block">
                <div className="block-header text-right">
                  <div className="block-title">
                    <h4 className="block-title">Purchase Order Details</h4>
                  </div>
                </div>

                <div className="block-body">
                  {/* <h5 class="card-title">Purchase Order Details</h5> */}
                  <table className="info-table">
                    <tbody>
                    <tr>
                      <td style={{width: '250px'}}>PO ID</td>
                      <td style={{width: '20px', textAlign: 'center'}}>:</td>
                      <td>{this.state.purchaseOrder &&
                      this.state.purchaseOrder.id}</td>
                    </tr>
                    <tr>
                      <td style={{width: '250px'}}>Master PO ID</td>
                      <td style={{width: '20px', textAlign: 'center'}}>:</td>
                      <td>{this.state.purchaseOrder &&
                      this.state.purchaseOrder.master_po_id}</td>
                    </tr>
                    <tr>
                      <td style={{width: '250px'}}>Supplier</td>
                      <td style={{width: '20px', textAlign: 'center'}}>:</td>
                      <td>{this.state.purchaseOrder &&
                      this.state.purchaseOrder.supplier_name}</td>
                    </tr>
                    <tr>
                      <td style={{width: '250px'}}>Creation Date</td>
                      <td style={{width: '20px', textAlign: 'center'}}>:</td>
                      <td>{this.state.purchaseOrder &&
                      getFormattedDate(this.state.purchaseOrder.order_date,'Do MMMM YYYY')}</td>
                    </tr>
                    <tr>
                      <td style={{width: '250px'}}>Quantity</td>
                      <td style={{width: '20px', textAlign: 'center'}}>:</td>
                      <td>{this.state.purchaseOrder &&
                      this.state.purchaseOrder.quantity}</td>
                    </tr>
                    <tr>
                      <td style={{width: '250px'}}>QC Status</td>
                      <td style={{width: '20px', textAlign: 'center'}}>:</td>
                      <td>{this.state.purchaseOrder &&
                      this.state.purchaseOrder.qc_status ? "Done" : "Not Done"}</td>
                    </tr>

                    <tr>
                      <td style={{ width: "250px" }}>Status</td>
                      <td style={{ width: "20px", textAlign: "center" }}>:</td>
                      <td>
                        {this.state.purchaseOrder &&
                        this.state.purchaseOrder.order_status
                          ? this.state.purchaseOrder.order_status
                          : "Unknown"}
                      </td>
                    </tr>
                    <tr>
                      <td style={{width: '250px'}}>Total Price</td>
                      <td style={{width: '20px', textAlign: 'center'}}>:</td>
                      <td>{this.state.purchaseOrder &&
                      this.state.purchaseOrder.total_price}</td>
                    </tr>
                    <tr>
                      <td style={{ width: "250px" }}>Paid</td>
                      <td style={{ width: "20px", textAlign: "center" }}>:</td>
                      <td>
                        {this.state.purchaseOrder?.paid | 0}
                      </td>
                    </tr>
                    <tr>
                      <td style={{width: '250px'}}>Pay Status</td>
                      <td style={{width: '20px', textAlign: 'center'}}>:</td>
                      <td>{this.state.purchaseOrder &&
                      this.state.purchaseOrder.pay_status}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          }
          <div className="card-block">
            <div className="block-header">
              <h4 className="block-title">Purchase Order Items</h4>
              <div className="ml-auto">
              { this.state.purchaseOrder?.line_items &&
                <ExportCSV data={this.state.purchaseOrder?.line_items } headers={headers} title="Purchase Order Items"/>}
              </div>
            </div>
              {
                this.state.isLoading ?
                  <div className={`card-block`}>
                    <div className="block-body">
                      Loading...
                    </div>
                  </div>
                  :
                  <div className="card">
                    <div className="card-body">
                      {/* <h5 class="card-title">Purchase Order Product List</h5> */}
                      <>
                        <table className="order-table table table-striped table-hover">
                          <thead>
                          <tr>
                            <th style={{width: '20px'}}>#</th>
                            <th>Product</th>
                            <th>SKU</th>
                            <th>Code By Supplier</th>
                            <th>Quantity</th>
                            <th>Total Price</th>
                          </tr>
                          </thead>
                          <tbody>
                          {this.state.purchaseOrder?.line_items?.length > 0 &&
                          this.state.purchaseOrder?.line_items?.map((orderItem, index) => {
                            return (
                              <tr key={index} onClick={() => this.setState({selectedRow: index})}>
                                <td>{index+1}</td>
                                <td>
                                  <div className="order-item">
                                    {orderItem.product_title}
                                  </div>
                                </td>
                                <td>
                                  <div className="order-item">
                                    {orderItem.sku}
                                  </div>
                                </td>
                                <td>
                                  <div className="order-item">
                                    {orderItem.code_by_supplier}
                                  </div>
                                </td>
                                <td>
                                  <div className="order-item">
                                    {orderItem.quantity}
                                  </div>
                                </td>
                                <td>
                                  <div className="order-item">
                                    {orderItem.total_price} BDT
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                          </tbody>
                        </table>
                      </>
                    </div>
                  </div>
              }
            {/* </div> */}
          </div>
        </div>
      </App>
    );
  }
}

export default withRouter(Details);